import { ProtectedComponent } from '@components'

import { Button, ButtonDropdown, ButtonsGroup, NavItem } from '@billy/design-system'
import Cookies from 'js-cookie'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

import { CookieKeys } from '../../../../../../enums/cookieKeys'
import { EmberRoute } from '../../../../../../enums/emberRoute'
import { Scope } from '../../../../../../enums/scope'
import { useSegment } from '../../../../../../hooks'
import { useEmberRouteUrl } from '../../../../../../hooks/routing/useEmberRouteUrl'

export const InvoicesSideActions = () => {
  const { t } = useTranslation()
  const { url: newInvoiceUrl } = useEmberRouteUrl(EmberRoute.InvoicesNew)
  const { url: newCreditNoteUrl } = useEmberRouteUrl(EmberRoute.InvoicesNewCreditNote)
  const navigate = useNavigate()
  const location = useLocation()
  const { track } = useSegment()

  const handleCreateCreditNote = useCallback(() => {
    track('XXX - Jesper - Action Taken', {
      context: 'invoice_list',
      action: 'more: create credit note',
    })

    Cookies.set(CookieKeys.InvoicesListQuery, location.search)
    if (newCreditNoteUrl) {
      navigate(newCreditNoteUrl)
    }
  }, [track, newCreditNoteUrl, navigate, location.search])

  const handleAction = (value: string) => {
    if (value === 'creditnote') {
      handleCreateCreditNote()
    }
  }

  const dropdownItems = useMemo(
    (): NavItem[] => [
      {
        id: 'creditnote',
        children: t('invoices.side_actions.create_credit_note'),
        value: 'create_credit_note',
      },
    ],
    [t],
  )

  const handleCreateInvoiceClick = useCallback(() => {
    track('XXX - Jesper - Action Taken', {
      context: 'invoice_list',
      action: 'create invoice',
    })

    Cookies.set(CookieKeys.InvoicesListQuery, location.search)
    if (newInvoiceUrl) {
      navigate(newInvoiceUrl)
    }
  }, [track, newInvoiceUrl, navigate, location.search])

  return (
    <ProtectedComponent scopes={Scope.InvoiceWrite}>
      <ButtonsGroup>
        <Button icon="circlePlus" onClick={handleCreateInvoiceClick}>
          {t('invoices.side_actions.create_invoice')}
        </Button>
        <ButtonDropdown items={dropdownItems} onSelect={handleAction} placement="top-start" variant="outlined">
          {t('invoices.side_actions.more')}
        </ButtonDropdown>
      </ButtonsGroup>
    </ProtectedComponent>
  )
}
